// extracted by mini-css-extract-plugin
export default {"MasterCardList":"MasterCardList_ZTzuz","MasterCardList___includesHeading":"MasterCardList___includesHeading_iO17w","MasterCardList_heading":"MasterCardList_heading_r3_OG"};